import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    cart: JSON.parse(localStorage.getItem('cart')) || []
  },
  mutations: {
    addItemToCart(state, item) {
      const existingItem = state.cart.find(i => i.id === item.id);
      if (existingItem) {
        existingItem.quantity += item.quantity;
      } else {
        state.cart.push(item);
      }
      this.commit('saveCartToLocalStorage');
    },
    removeItemFromCart(state, itemId) {
      state.cart = state.cart.filter(item => item.id !== itemId);
      this.commit('saveCartToLocalStorage');
    },
    updateItemQuantity(state, { itemId, quantity }) {
      const item = state.cart.find(i => i.id === itemId);
      if (item) {
        item.quantity = quantity;
      }
      this.commit('saveCartToLocalStorage');
    },
    saveCartToLocalStorage(state) {
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },
    clearCart(state) {
      state.cart = [];
      this.commit('saveCartToLocalStorage');
    }
  },
  actions: {
    addItemToCart({ commit }, item) {
      commit('addItemToCart', item);
    },
    removeItemFromCart({ commit }, itemId) {
      commit('removeItemFromCart', itemId);
    },
    updateItemQuantity({ commit }, { itemId, quantity }) {
      commit('updateItemQuantity', { itemId, quantity });
    }
  },
  getters: {
    cart(state) {
      return state.cart;
    }
  }
});
